import { MatchRepository } from "../repositories/MatchRepository";

export class SendPaidMessage {
	constructor(private repository: MatchRepository) {}
	execute(data: SendPaidMessageParams): Promise<void> {
		return this.repository.sendPaidMessage(data.user_id, data.message);
	}
}

export class SendPaidMessageParams {
	constructor(public user_id: string, public message: string) {}
}
